import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const ProjectSsrPage = lazy(() => import("./projectSsr"));

export const projectPageSsrProps = {
    ssrEnabled: false,
    ssrComponent: (ssrProps: any) => <ProjectSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <ProjectSsrPage {...ssrProps} />,
}

export const projectPageSsrEnabledProps = {
    ...projectPageSsrProps,
    ssrEnabled: true,
}
import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const ProjectSsrPage = lazy(() => import("./projectSsr"));

export const projectPageSsrProps = {
    ssrEnabled: false,
    ssrComponent: (ssrProps: any) => <ProjectSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <ProjectSsrPage {...ssrProps} />,
}

export const projectPageSsrEnabledProps = {
    ...projectPageSsrProps,
    ssrEnabled: true,
}
